import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PopupRef, UiIconModel } from '@local/ui-infra';
import { getExtensionByFileName, getIconByExtension } from '@local/ts-infra';

export interface UploadFilesFailedPopupData {
  files: File[];
  title: string;
  primaryButtonText: string;
  secondaryButtonText: string;
}

export interface viewModelFile {
  name: string;
  size: number;
  icon: UiIconModel;
}

@UntilDestroy()
@Component({
  selector: 'upload-files-failed-popup',
  templateUrl: './upload-files-failed-popup.component.html',
  styleUrls: ['./upload-files-failed-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFilesFailedPopupComponent {
  data: UploadFilesFailedPopupData;
  files: viewModelFile[] = [];

  @Output() primaryButton = new EventEmitter();
  @Output() secondaryButton = new EventEmitter();

  constructor(private ref: PopupRef<UploadFilesFailedPopupComponent, UploadFilesFailedPopupData>) {}

  ngOnInit(): void {
    if (!this.ref.data) return;
    this.data = this.ref.data;
    this.data.files.forEach((f) => {
      const iconName = getIconByExtension(getExtensionByFileName(f.name));
      this.files.push({ name: f.name, size: f.size, icon: { type: 'img', value: { lightUrl: iconName } } });
    });
  }

  onSecondaryButton() {
    this.secondaryButton.emit();
    this.close();
  }

  onPrimaryButton() {
    this.primaryButton.emit();
    this.close();
  }

  close() {
    this.ref.destroy();
  }
}
